import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { config } from '../../../../assets/config';


@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  // public MGAPIUrl: string = config.apiHostClient + config.apiURL + config.apiHostVersion;

  // public MGAPIUrl: string = environment.apiHostClient + environment.apiURL + environment.apiHostVersion;
  public MGAPIUrl: string = config.apiHostClient + config.apiURL + config.apiHostVersion;

  // MGAPIUrl: string;

  constructor() {
    // this.readConfiguration().then(result => {
    //   this.MGAPIUrl = result.apiHostClient + result.apiURL + result.apiHostVersion;
    //   console.log(this.MGAPIUrl);
    // });
  }


  public baseUrl(): string {
    // this.MGAPIUrl = localStorage.getItem('url');
    return `${this.MGAPIUrl}`;
  }

  public createUrl(actionName: string): string {
    // this.MGAPIUrl = localStorage.getItem('url');
    return `${this.MGAPIUrl}${actionName}`;
  }


  public returnAction(actionName: string): string {
    return `${actionName}`;
  }

}
